import { IconInfoCircle, IconX } from '@tabler/icons-react';
import IconButtonGroup from '@/components/atoms/Button/IconButtonGroup';

const ContentUploadProgress = ({
  onCancel,
  totalPercentageUploaded,
  file
}: {
  onCancel: () => void;
  totalPercentageUploaded: number;
  file: File;
  isVisible?: boolean;
}) => {
  return (
    <div className="flex size-full items-center justify-center">
      <div className="flex w-full flex-col justify-center">
        <div className="pointer-events-auto rounded-lg border bg-white p-3">
          <div className="flex w-full items-center justify-between">
            <div className="flex flex-col !items-start !space-x-0">
              <div className="flex items-center">
                <span className="text-sm font-medium">
                  {file.name}
                  <span className="ml-2 text-slate-400">{`${totalPercentageUploaded}%`}</span>
                </span>
              </div>
              <div className="mt-1 flex items-start text-xs font-normal text-slate-600">
                <IconInfoCircle size={16} stroke={2} className="mr-1 text-slate-400" />
                Uploading your file, please wait...
              </div>
            </div>
            <div className="inline-flex h-8 divide-x rounded-lg text-xs">
              <IconButtonGroup
                variation="list"
                buttons={[
                  {
                    content: '',
                    description: 'Cancel',
                    icon: IconX,
                    action: onCancel,
                    trackingId: 'cancel-upload-button'
                  }
                ]}
              />
            </div>
          </div>
          <div className="mt-2.5 w-full rounded-full bg-gray-200 dark:bg-gray-700">
            <div
              className="h-2 rounded-full bg-deep-orange p-0.5 text-center text-xs font-medium leading-none text-blue-100 transition-all duration-500 ease-in-out"
              style={{ width: `${totalPercentageUploaded}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentUploadProgress;
